import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.scss';
import colors from '@loggi/ui/components/utils/colors';

const COLORS = colors.type;

function Spinner({ className, size, color, strokeWidth }) {
  const svgStyle = { width: size, height: size, display: 'inlineBlock' };
  const pathStyle = { stroke: color ? colors.hex[color] : null, strokeWidth };

  /* eslint-disable */
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 50 50"
      preserveAspectRatio="none"
      style={svgStyle}
    >
      <path
        className={styles.shapeCircleLoader}
        style={pathStyle}
        d="M5,24.5 C5,13.7304474 13.7280795,5 24.5,5 L24.5,5
        C35.2695526,5 44,13.7280795 44,24.5 L44,24.5
        C44,35.2695526 35.2719205,44 24.5,44 L24.5,44
        C13.7304474,44 5,35.2719205 5,24.5 L5,24.5 Z"
      />
    </svg>
  );
}

Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  style: PropTypes.object,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.oneOf([
    COLORS.WHITE,
    COLORS.ACTIVE,
    COLORS.INFO,
    COLORS.SUCCESS,
    COLORS.DANGER,
    COLORS.WARNING,
    COLORS.DARK,
    COLORS.MEDIUM,
    COLORS.LIGHT
  ]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Spinner.defaultProps = {
  size: '1em',
  strokeWidth: '0.5rem',
  color: COLORS.ACTIVE
};

export default Spinner;
